import { Component } from '@angular/core';

@Component({
  selector: 'app-pr4',
  templateUrl: './pr4.component.html',
  styleUrls: ['./pr4.component.scss']
})
export class Pr4Component {
  // Add any component logic here
}